import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import * as config from '../../../shared/config/app.config';
import { BaseService } from "../../services/base.service";
import { SharedService } from "../../services/shared.service";

@Injectable({
  providedIn: 'root'
})
export class FutureCartService {

  public futureShipCarts = new BehaviorSubject<any>(false);
  futureShipCarts$ = this.futureShipCarts.asObservable();
  public updateCartDetails = new BehaviorSubject<any>(false);
  updateCartDetails$ = this.updateCartDetails.asObservable();

  constructor(private readonly baseService: BaseService,
    private readonly sharedService: SharedService,
    private readonly plpService: CustomProdPgService,
    private _dataService: DataLayerService) { }

  getFutureShipCarts(userId?, accountNo?): void {
    if (userId && accountNo) {
      //this.futureShipCarts.next(false);
      this.baseService.get(`${userId}/${accountNo}/futureShip/get-futureship-products?fields=DEFAULT`).subscribe((res) => {

        if (!!res) {
          this.futureShipCarts.next(res);
          //set session storage
          this.sharedService.setLocalStorage(
            'implicitOptIn',
            res.impOptIn
          );
          // this.sharedService.setLocalStorage(
          //   'implicitOptIn',
          //   false
          // );
          this.sharedService.setLocalStorage(
            'futureShippingEndDate',
            res.shippingEndDate
          );
          this.sharedService.setLocalStorage(
            'schedulerContent',
            res.scheduleFutShipContent
          );
          if (res.shipNowProducts) {
            let shipNowProductCode = res.shipNowProducts.map(x => {
              return x.code;
            })
            this.sharedService.setLocalStorage(
              'shipNowProducts',
              JSON.stringify(shipNowProductCode)
            );
          }
          let futureShipProducts = res.product.map(x => {
            return x.code;
          });
          this.sharedService.setLocalStorage(
            'futureShipProducts',
            JSON.stringify(futureShipProducts)
          );
          this.sharedService.setLocalStorage(
            'catalogModal',
            res.catalogModal
          );
          if (res.categories) {
            let categories = res.categories.map(x => {
              return x.code;
            })
            this.sharedService.setLocalStorage(
              'futureshipCategories',
              JSON.stringify(categories)
            );
          } else {
            this.sharedService.setLocalStorage(
              'futureshipCategories',
              JSON.stringify([])
            );
          }

          if (res.hasOwnProperty('displayFutureShipModal')) {
            this.sharedService.setLocalStorage(
              'eligibleContract',
              res.displayFutureShipModal
            );
          } else {
            this.sharedService.setLocalStorage(
              'eligibleContract',
              true
            );
          }
        }
        //shipping start date
        this.sharedService.setLocalStorage(
          'futureShipStartDate',
          res?.shippingStartDate
        );

      });
    }
    else {
      this.futureShipCarts.next(false);
    }
  }

  public updateCart(productDetails, userId, cartId): void {
    this.plpService.cartDetailsUpdate.next(false);
    this.plpService.minicartUpdate.next(false);
    this.baseService.post(config.USER_ACCOUNT + userId + '/carts/' + cartId + '/entries?fields=DEFAULT', productDetails).subscribe((res) => {
      if (res) {
        this.updateCartDetails.next(true);
        this.plpService.cartDetailsUpdate.next(true);
        this.plpService.minicartUpdate.next(true);
      }
    })
  }

  public addToCart(userId, data, cartId, productDetails): Observable<any> {
    //GTM
    data?.selectedLocationIds?.forEach(el => {
      this._dataService.addtoDataLayer('add_to_cart_futureship', productDetails, data, el);
    });
    this._dataService.addtoDataLayer('clearDataLayer', '', '', '');
    return this.baseService
      .post(
        config.USER_ACCOUNT + userId + '/carts/' + cartId + '/addItems?fields=DEFAULT&updateQuantity=false',
        data
      );
  }
}
